<div class="padded-page">
  <bs-loading message="Please wait"></bs-loading>
</div>
